import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleOperador } from "../hooks/roles/ProtectedRoleOperador";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleResolverOperador = React.lazy(
  () =>
    import(
      "../components/task/operador/tareaDetalleResolverOperador/tarea-detalle-resolver-operador"
    )
);
export function tareaDetalleResolverOperador() {
  return (
    <Route
      path="/tarea-detalle-resolver-operador"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleOperador>
              <LazySuspense>
                <TareaDetalleResolverOperador />
              </LazySuspense>
            </ProtectedRoleOperador>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
